import { Box, Button, Table, Text } from '@factorialco/deprecated-design-system'

import MoneyField from 'modules/core/components/MoneyField'
import TextField from 'modules/core/components/TextField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import type { QuoteItem } from 'modules/finance/components/Quotes/QuotePhasesTable/types'

interface ItemRowProps {
  item: QuoteItem
  currency: string
  onUpdate: (updates: Partial<QuoteItem>) => void
  onDelete: () => void
}

const ItemRow = ({ item, currency, onUpdate, onDelete }: ItemRowProps) => {
  const {
    access: { locale },
  } = useCurrentSession()
  const totalCost = item.hoursOrUnits * item.costPerUnit
  const totalToBill = item.hoursOrUnits * item.billPerUnit

  return (
    <Table.Row>
      <Table.Cell colSpan={2}>
        <Box paddingLeft="s24" width="s300">
          <TextField
            placeholder={i18n.t('common.name')}
            value={item.name}
            onChange={(value) => onUpdate({ ['name']: value })}
          />
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box width="s96">
          <MoneyField
            placeholder="0"
            currency={item.itemType === 'role' ? 'hr' : 'u'} // TODO: Translate
            onChange={(value) => onUpdate({ ['hoursOrUnits']: Number(value) })}
            value={item.hoursOrUnits.toString()}
          />
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: item.costPerUnit,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: item.billPerUnit,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {`${item.profit.toFixed(2)}\u00A0%`}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: totalCost,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: totalToBill,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={1} width={80}>
        <Button type="secondary" iconName="delete" onClick={onDelete} />
      </Table.Cell>
    </Table.Row>
  )
}

export default ItemRow
